define('GiftCertificateVariableAmount.Transaction.Line.Price.View', [
    'Backbone',
    'underscore',
    'giftcertificatevariableamount_cartview.tpl',
    'Transaction.Line.Views.Price.View'
], function GiftCertificateVariableAmountCartView(
    Backbone,
    _,
    giftcertificatevariableamountCartviewTpl,
    TransactionLineViewsPriceView
) {
    'use strict';

    TransactionLineViewsPriceView.prototype.getContext =
      _.wrap(TransactionLineViewsPriceView.prototype.getContext, function wrapItemDetailsView(fn) {
          var context = fn.call(this);
          var isGiftCert = this.model.get('item').get('_itemType');
          var isWithVariableAmount = this.model.get('item').get('custitem_is_variable_amount');

          // For GiftCertificate Enhancement Module Only
          if (isGiftCert && isWithVariableAmount) {
            context.rateFormatted = this.model.get('rate_formatted') || price_container_object.price_formatted || ''
          }

          return context;
      });
});
